import React, { memo } from 'react';
import makeBodyText from '../../utils/makeText';
import styles from './index.module.scss';
const DeedsInNumbers = memo(({ itemsList }) => {
    return (React.createElement("div", { className: styles.deedsWrap }, itemsList.map(({ label, description }) => (React.createElement("div", { className: styles.itemWrap, key: label },
        React.createElement("h4", { className: `${makeBodyText('S')} ${styles.label}` },
            React.createElement("strong", null, label.toUpperCase())),
        React.createElement("p", { className: `${makeBodyText('XL')} ${styles.text}` },
            React.createElement("strong", null, description)))))));
});
DeedsInNumbers.displayName = 'DeedsInNumbers';
export default DeedsInNumbers;
